import { render, staticRenderFns } from "./DisqualificationDetail.vue?vue&type=template&id=b33c5d18"
import script from "./DisqualificationDetail.vue?vue&type=script&lang=js"
export * from "./DisqualificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports